<template>
  <div
    class="min-h-screen bg-black text-white py-8 px-4 md:px-8 md:mt-16"
    :key="isFighter"
  >
    <section class="w-full md:w-1/2 mx-auto">
      <div class="flex flex-col items-centergap-6 container">
        <!-- Avatar -->
        <div class="w-full flex justify-center mb-2">
          <div
            class="w-32 h-32 rounded-full overflow-hidden border-2 border-[#d20a0a] shadow-md flex justify-center"
          >
            <img
              :src="
                customer?.avatar !== null && customer?.avatar !== '[]'
                  ? customer?.avatar
                  : banner
              "
              alt="Avatar"
              class="w-full h-full object-cover"
            />
          </div>
        </div>

        <!-- Dados e formulário -->
        <div class="flex-1 w-full">
          <h2 class="text-3xl font-bold text-center text-white mb-6">
            Olá {{ customer?.name }}
          </h2>

          <div
            class="bg-zinc-900 p-6 rounded-xl shadow-md font-inter text-left"
          >
            <form class="space-y-4">
              <div v-if="customer?.name">
                <label class="block text-sm text-gray-300 mb-1">Nome</label>
                <input
                  v-model="customer.name"
                  type="text"
                  class="w-full rounded-lg p-2 bg-zinc-800 text-white border border-zinc-700"
                />
              </div>

              <div v-if="customer?.email">
                <label class="block text-sm text-gray-300 mb-1"
                  >e-mail | acesso</label
                >
                <input
                  v-model="customer.email"
                  type="email"
                  class="w-full rounded-lg p-2 bg-zinc-800 text-white border border-zinc-700"
                />
              </div>

              <!-- <div>
                <label class="block text-sm text-gray-300 mb-1">Nova senha</label>
                <input
                  v-model="dataShared.state.profile.p_password"
                  type="password"
                  class="w-full rounded-lg p-2 bg-zinc-800 text-white border border-zinc-700"
                />
              </div> -->

              <div class="flex flex-col gap-2 items-center w-full">
                <button
                  type="submit"
                  @click.prevent="updateProfileData()"
                  class="text-white bg-[#d20a0a] hover:bg-white hover:text-red-700 transition-colors duration-300 font-bold py-2 px-6 rounded-lg md:w-2/5 w-full"
                >
                  Salvar Alterações
                </button>

                <router-link
                  :to="{ name: 'auth' }"
                  class="text-[#d20a0a] bg-[#fff] hover:bg-[#d20a0a] hover:text-white transition-colors duration-300 font-bold py-2 px-6 rounded-lg md:w-2/12 w-full text-center"
                >
                  Sair
                </router-link>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>

    <!-- adquiridos -->
    <section class="px-6 md:px-20 py-10">
      <h2 class="text-xl md:text-2xl font-semibold mb-4 uppercase text-start">
        MEUS TREINAMENTOS
      </h2>

      <div v-if="customer?.purchases?.length && customer?.purchases[0]?.event">
        <Carrossel>
          <CardEventoPreview
            v-for="(item, index) in customer?.purchases"
            :key="index"
            :image="
              customer?.purchases[index]?.event?.banner !== null &&
              customer?.purchases[index]?.event?.banner !== '[]'
                ? fileUrl + customer?.purchases[index]?.event?.banner
                : banner
            "
            :title="customer?.purchases[index]?.event?.title"
            :tag="customer?.purchases[index]?.event?.tag"
            :live="customer?.purchases[index]?.event?.is_live"
            @click="
              watchEvent(
                customer?.purchases[index]?.event,
                customer?.purchases[index].group_id
              )
            "
          />
        </Carrossel>
      </div>
      <div class="w-full py-3 italic" v-else>
        Você ainda não possui treinamentos
      </div>
    </section>

    <!-- participações -->
    <section class="px-6 md:px-20 py-10">
      <div class="flex gap-x-3">
        <h2
          class="text-white text-xl md:text-2xl font-semibold mb-4 uppercase text-start"
        >
          MEUS CERTIFICADOS
        </h2>
        <h2
          class="text-gray-600 text-xl md:text-2xl font-semibold mb-4 uppercase text-start"
        >
          TREINAMENTOS CONCLUÍDOS
        </h2>
      </div>

      <div v-if="customer?.coupon?.length > 0">
        <Carrossel>
          <CardEventoPreview
            v-for="(item, index) in customer?.coupon"
            :key="index"
            :image="
              item?.event?.banner !== null && item.event?.banner !== '[]'
                ? fileUrl + item.event?.banner
                : banner
            "
            :title="item?.event?.title"
            :tag="item.event?.tag"
            :live="item.event?.is_live"
            @click="goSponsorshipPage(item.event?.id, item)"
          />
        </Carrossel>
      </div>

      <div class="w-full py-3" v-else>
        Ainda não há certificados disponíveis
      </div>
    </section>
  </div>
</template>

<script setup>
import { onMounted, computed } from "vue";
import CardEventoPreview from "../auth/components/CardEventoPreview.vue";
import SharedService from "@/shared/services/shared";
import { dataShared } from "@/shared/store";
import defaultLogo from "@/assets/logo/plataforma_x/xsolution_logo.png";

// import bgDownload from '@/assets/bgDownload.webp'
// import TitleSection from '@/shared/components/__partials/TitleSection.vue'
// import { formatDate } from '@/utils/formaters'
// const customerId = computed(() => customer.value?.id)

import { showToast as toast } from "@/helpers/UseToasts";
import router from "@/router";
import Carrossel from "../auth/components/_partials/Carrossel.vue";

const banner = computed(() => {
  return defaultLogo;
});
const customer = computed(() => dataShared.getters.getDataByUserLogged);

const fileUrl = process.env.VUE_APP_IMAGE_SERVE + "storage/";
const isFighter = computed(() => customer.value?.is_fighter);

// function beAFighter () {
//   dataShared.dispatch('activeLoading')

//   SharedService.beAFighter(customerId.value)
//     .then(res => {
//       if (res.data.success) {
//         toast(
//           'Aviso',
//           res.data.message,
//           'success'
//         )
//       }

//       dataShared.dispatch('desactiveLoading')
//     }).catch(err => {
//       dataShared.dispatch('desactiveLoading')

//       if (err?.response?.data?.error && err.response.data.status === 400) {
//         return toast(
//           'Aviso',
//           err.response.data.message,
//           'error'
//         )
//       }

//       if (err?.response?.data?.error && err.response.data.status === 404) {
//         return toast(
//           'Aviso',
//           err.response.data.message,
//           'error'
//         )
//       }

//       return toast(
//         'Aviso',
//         'Algo deu errado com sua solicitação',
//         'error'
//       )
//     })
// }

function goSponsorshipPage(eId, payload) {
  router.push({
    name: "purchase",
    params: { id: eId },
    query: {
      fighter: payload?.fighter_id,
      affiliate: payload?.secret,
    },
  });
}

async function watchEvent(event, groupId = null) {
  dataShared.dispatch("activeLoading");

  await SharedService.watchEventById(event?.id)
    .then((res) => {
      dataShared.dispatch("setEventToPurchase", event?.id);

      if (res.data.success == false) {
        dataShared.dispatch("desactiveLoading");
        toast("Aviso", "Adquira acesso a este evento", "info");
        return router.push(`/training/${event?.id}/purchase`);
      }

      dataShared.dispatch("desactiveLoading");
      dataShared.dispatch("setLiveActive", event?.id);
      // router.push(`/module/${event?.id}`)
      router.push({
        path: `/module/${event?.id}`,
        query: groupId ? { group: groupId } : {},
      });
    })
    .catch((err) => {
      console.log(err);
    });
}

async function updateProfileData() {
  dataShared.dispatch("activeLoading");

  const data = {
    p_name: dataShared.state.dataUserLogged?.name,
    p_email: dataShared.state.dataUserLogged?.email,
  };

  await SharedService.updateData(data)
    .then((res) => {
      if (res?.data.success) {
        toast("Sucesso", res.data.message, "success");
      }
    })
    .catch((err) => {
      dataShared.dispatch("desactiveLoading");

      if (err?.response?.data?.error && err.response.data.status === 400) {
        return toast("Aviso", err.response.data.message, "error");
      }

      return toast("Aviso", "Algo deu errado com sua solicitação", "error");
    });

  dataShared.dispatch("desactiveLoading");
}

onMounted(async () => {
  dataShared.dispatch("activeLoading");
  await dataShared.dispatch("fetchLoggedUser");
  dataShared.dispatch("desactiveLoading");
});
</script>

<style scoped>
::-webkit-scrollbar {
  height: 6px;
}
::-webkit-scrollbar-thumb {
  background-color: #d20a0a;
  border-radius: 10px;
}
</style>
